const Cloud = ({ className }) => (
  <div className={`absolute rounded-full bg-[rgba(255,255,255,0.8)] dark:bg-[rgba(255,255,255,0.6)] ${className}`}>
    <div className="absolute left-4 -top-6 w-12 h-12 rounded-full bg-[rgba(255,255,255,0.8)] dark:bg-[rgba(255,255,255,0.6)]" />
    <div className="absolute -top-8 left-10 w-16 h-16 rounded-full bg-[rgba(255,255,255,0.8)] dark:bg-[rgba(255,255,255,0.6)]" />
  </div>
);

export default Cloud; 